import { _WINDOW_ } from "constants/dom";

const dispatchJSEvent = (event: string, detail?: object | null): void => {
  _WINDOW_.dispatchEvent(new CustomEvent(event, { detail }));
};

export default dispatchJSEvent;
